import {NgbDate} from '@ng-bootstrap/ng-bootstrap';

export enum UploadId {
  dopUploadID = 'dopUploadID',
  alkisUploadID = 'alkisUploadID',
  ndomUploadID = 'ndomUploadID',
  landcoverUploadID = 'landcoverUploadID',
  trainingDataUploadID = 'trainingDataUploadID',
  validationDataUploadID = 'validationDataUploadID',
  cdFilterUploadID = 'cdFilterUploadID',
  cdMaskUploadID = 'cdMaskUploadID',
}

export interface ProductType {
  id: string;
  name: string;
  disabled?: boolean;
  selected?: boolean;
}

/**
 * Each entry in the shopping cart is a single product
 */

export class Product {
  automaticTraining: boolean;
  bezirksregierung: string[];
  bundesland: string[];
  drawnGeometry: any;
  endDate: NgbDate;
  flur: string[];
  gemarkung: string[];
  dopUploadID: string;
  alkisUploadID: string;
  ndomUploadID: string;
  landcoverUploadID: string;
  trainingDataUploadID: string;
  validationDataUploadID: string;
  cdFilterUploadID: string;
  cdMaskUploadID: string;
  kommune: string[];
  kreis: string[];
  lbQuality: boolean;
  matrix: any;
  orderId: string;
  orderName: string;
  productType: string;
  selectedRegions: string[];
  startDate: NgbDate;

  constructor() {
    const date = new Date();
    this.automaticTraining = false;
    this.bezirksregierung = [];
    this.bundesland = [];
    this.drawnGeometry = null;
    this.endDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    this.flur = [];
    this.gemarkung = [];
    this.dopUploadID = '';
    this.alkisUploadID = '';
    this.ndomUploadID = '';
    this.landcoverUploadID = '';
    this.trainingDataUploadID = '';
    this.validationDataUploadID = '';
    this.cdFilterUploadID = '';
    this.cdMaskUploadID = '';
    this.kommune = [];
    this.kreis = [];
    this.lbQuality = false;
    this.matrix = null;
    this.orderId = '';
    this.orderName = '';
    this.productType = '';
    this.selectedRegions = [];
    this.startDate = new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
  }
}

export interface RequestList {
  producingservername: string;
  deliverytype: string;
  product: RequestProduct;
}

export interface RequestProduct {
  description: string;
  productid: string;
  productname: string;
  fselection: string;
  productparameters: ProductParameter[];
}

export interface ProductParameter {
  id: string;
  isUsed: boolean;
  showInShoppingbasket: boolean;
  isPricingParam: boolean;
  valueName: string;
  isCostParam: boolean;
  isConfigurationParam: boolean;
  name: string;
  value: string;
  customerOrderID?: string;
}

export class AEDrequest {
  requestlist: RequestList[] = [{
    producingservername: 'WOSConnectorCop4ALLServer',
    deliverytype: 'HTTP',
    product: {
      description: 'Testbestellung',
      productid: 'cop4all',
      productname: 'Cop4ALL NRW',
      fselection: '',
      productparameters: [{
        id: 'FE-Auftrag',
        isUsed: true,
        showInShoppingbasket: false,
        isPricingParam: false,
        valueName: 'FE-Auftrag',
        isCostParam: false,
        isConfigurationParam: true,
        name: 'FE-Auftrag',
        value: ''
      }, {
        id: 'Bestellnummer',
        isUsed: true,
        showInShoppingbasket: true,
        isPricingParam: false,
        valueName: '',
        isCostParam: false,
        isConfigurationParam: true,
        name: 'Bestellnummer',
        value: '',
        customerOrderID: ''
      }]
    }
  }];
}
